import { singleListing } from "@/__generated__/listings";

import { LISTING_STATUS_CODE } from "../common/const";

export const BULK_ACTIONS = {
  delete: "delete" as "delete",
  offline: "offline" as "offline",
  reactivate: "reactivate" as "reactivate",
  republish: "republish" as "republish",
  readvertise: "readvertise" as "readvertise",
  schedule: "schedule" as "schedule",
  export: "export" as "export",
  upgrade_to_feature_7: "upgrade_to_feature_7" as "upgrade_to_feature_7",
  upgrade_to_feature_28: "upgrade_to_feature_28" as "upgrade_to_feature_28",
  extend: "extend" as "extend",
  duplicate: "duplicate" as "duplicate",
};

export const SINGLE_ACTIONS = {
  delete: "delete",
  upgrade: "upgrade",
  reactivate: "reactivate",
  cancelAutoUpgrade: "cancelAutoUpgrade",
} as const;

export const OTHER_ACTIONS = {
  batch_upload: "batch_upload" as "batch_upload",
  view_degraded: "view_degraded" as "view_degraded",
};

export type BulkActions = keyof typeof BULK_ACTIONS | null;
export type OtherActions = keyof typeof OTHER_ACTIONS | null;
export type SingleActions = keyof typeof SINGLE_ACTIONS | null;
export type MessageActions = BulkActions | SingleActions | OtherActions;
export type OperationResponse = {
  message: string;
  errors: OperationError[];
};

export type OperationError = {
  listing?: singleListing;
  error?: {
    messages: string[] | string;
    code: number;
  };
};

export interface MessageResponse {
  error?: {
    message: string;
    action: MessageActions;
    list: OperationError[];
    closeable?: boolean;
    isHiddenActionLink?: boolean;
  };
  success?: {
    message: string;
    action: MessageActions;
    list: OperationError[];
    closeable?: boolean;
    isHiddenActionLink?: boolean;
  };
}
export interface MessageProps {
  id?: string;
  type: "success" | "error";
  message: string;
  hasLink: boolean;
  closeable?: boolean;
  linkContent: {
    action: MessageActions;
    list: OperationError[];
    url?: string;
  } | null;
}

export type HandleBulkAction = (
  generateError: (
    id: string,
    graphQLErrors: [
      { errors: string | string[]; statusCode: number; message: string }
    ]
  ) => OperationError,
  updateProgress: (finishedCount: number, all: number) => void
) => Promise<OperationError[]>;

export const parseStatusToString = (code: number) => {
  switch (code) {
    case LISTING_STATUS_CODE.ONLINE:
      return "online";
    case LISTING_STATUS_CODE.DRAFT:
      return "draft";
    case LISTING_STATUS_CODE.OFFLINE:
      return "offline";
    case LISTING_STATUS_CODE.EXPIRED:
      return "expired";
  }
  return "";
};
